import { createRoot } from 'react-dom/client';

import { GlobalRouter } from './GlobalRouter';
import { initSentry } from './services/sentry';
import './polyfills';

import '@livechat/design-system-react-components/dist/design-system-react-components.css';
import './index.css';

initSentry();
createRoot(document.getElementById('root')!).render(<GlobalRouter />);
